var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 9.16732C3.33203 8.8137 3.47251 8.47456 3.72256 8.22451C3.9726 7.97446 4.31174 7.83398 4.66536 7.83398H11.332C11.6857 7.83398 12.0248 7.97446 12.2748 8.22451C12.5249 8.47456 12.6654 8.8137 12.6654 9.16732V13.1673C12.6654 13.5209 12.5249 13.8601 12.2748 14.1101C12.0248 14.3602 11.6857 14.5007 11.332 14.5007H4.66536C4.31174 14.5007 3.9726 14.3602 3.72256 14.1101C3.47251 13.8601 3.33203 13.5209 3.33203 13.1673V9.16732Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 7.83333V5.16667C5.33203 4.45942 5.61298 3.78115 6.11308 3.28105C6.61318 2.78095 7.29145 2.5 7.9987 2.5C8.70594 2.5 9.38422 2.78095 9.88432 3.28105C10.3844 3.78115 10.6654 4.45942 10.6654 5.16667V7.83333M7.33203 11.1667C7.33203 11.3435 7.40227 11.513 7.52729 11.6381C7.65232 11.7631 7.82189 11.8333 7.9987 11.8333C8.17551 11.8333 8.34508 11.7631 8.4701 11.6381C8.59513 11.513 8.66536 11.3435 8.66536 11.1667C8.66536 10.9899 8.59513 10.8203 8.4701 10.6953C8.34508 10.5702 8.17551 10.5 7.9987 10.5C7.82189 10.5 7.65232 10.5702 7.52729 10.6953C7.40227 10.8203 7.33203 10.9899 7.33203 11.1667Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.bd02ba2148d5d26c2be8b9ed79ce17d5.svg";
export { ForwardRef as ReactComponent };